import { ReactElement, FC, useState, useEffect, memo } from 'react'
import { Link } from 'react-router-dom'

import { getVendors } from '../../../constants'
import { useI18n } from '../../../hooks'
import Image from '../../atoms/images/image'

const PRODUCT_NUMBER = 670

const ProductOfferings: FC = (): ReactElement => {
  const [showNumber, setShowNumber] = useState(0)
  const [iconMovePosition, setIconMovePosition] = useState<string[]>(getVendors().map((): string => '(0, 0)'))

  const getRadomPosition = (): string => {
    const x = Math.floor(Math.random() * 150)
    const y = Math.floor(Math.random() * 100)
    return `(${x}px, ${y}px)`
  }

  useEffect(() => {
    const newIconPosition = getVendors().map((): string => getRadomPosition())
    setIconMovePosition(newIconPosition)
  }, [])

  useEffect(() => {
    if (showNumber < PRODUCT_NUMBER) {
      const timeout = setTimeout(() => {
        setShowNumber(showNumber + 10)
      }, 15)
      return () => {
        clearTimeout(timeout)
      }
    }
  }, [showNumber])

  useEffect(() => {
    const timeout = setTimeout((): void => {
      const newIconPosition = getVendors().map((): string => getRadomPosition())
      setIconMovePosition(newIconPosition)
    }, 10000)
    return () => {
      clearTimeout(timeout)
    }
  }, [iconMovePosition])
  const { t } = useI18n()
  return (
    <div className="about-product-offerings">
      <div className="about-product-offerings-info">
        <h1 className="heavy">{showNumber}+</h1>
        <p>{t('About_productOfferings')} </p>
        <Link to="/shop?category=top deals">
          <button className="light">{t('Categories_topDeals')}</button>
        </Link>
      </div>
      <div className="about-product-offerings-logos">
        {getVendors().map((vendor, i) => (
          <Link
            style={{
              transform: `translate${iconMovePosition[i]}`,
            }}
            className="vendor-anchor"
            key={vendor.name + i}
            to={vendor.url}
            target="_blank"
            rel="noreferrer"
            aria-label={t('Vendor_readMore') + ': ' + vendor.name}
          >
            <Image
              className="vendor-icon"
              src={vendor.icon}
              size={{ width: 130, height: 30 }}
              alt={vendor.name + t('Vendor_icon')}
              aria-label={vendor.name + t('Vendor_icon')}
            />
          </Link>
        ))}
      </div>
    </div>
  )
}

export default memo(ProductOfferings)
